import { j as s } from "../accordion/Accordion-CrPiD_81.mjs";
import { forwardRef as c } from "react";
const f = c(
  ({
    children: d,
    buttonType: n,
    buttonStyle: r,
    type: o = "button",
    isLoading: t = !1,
    lightBackground: a = !1,
    transparent: i = !1,
    disabled: u,
    className: b = "",
    "aria-busy": l,
    icon: e,
    iconClass: m = "",
    ...$
  }, _) => /* @__PURE__ */ s.jsx(
    "button",
    {
      type: o,
      ...$,
      ref: _,
      disabled: t || u,
      "aria-busy": t || l,
      className: `
        ${n}
        rds-button__shared
        rds-button__shared--${r}
        rds-button--${r}
        ${t ? "rds-button--loading" : ""}
        ${a ? "rds-light" : ""}
        ${a === "white" ? "rds-white" : ""}
        ${i ? "rds-transparent" : ""}
        ${b}`,
      children: /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
        e && /* @__PURE__ */ s.jsx("span", { "data-testid": "rds-button__icon", className: `rds-button__icon ${m}`, children: /* @__PURE__ */ s.jsx(e, {}) }),
        d
      ] })
    }
  )
);
f.displayName = "BaseButton";
export {
  f as B
};
